import { render } from "./FlowPage.vue?vue&type=template&id=52da288c&scoped=true"
import script from "./FlowPage.vue?vue&type=script&lang=js"
export * from "./FlowPage.vue?vue&type=script&lang=js"

import "./FlowPage.vue?vue&type=style&index=0&id=52da288c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52da288c"]])

export default __exports__